'use client';

import { cn } from '../../../../lib/utils';
import type { ComponentType } from 'react';
import { useColorPickerContext } from './color-picker-context';
import * as GradientPickerModule from 'react-best-gradient-color-picker';

export interface ColorPickerGradientAreaProps {
  className?: string;
}

type GradientPickerProps = {
  value: string;
  onChange: (value: string) => void;
  hideColorGuide?: boolean;
};

type GradientPickerComponent = ComponentType<GradientPickerProps>;

const GradientPicker =
  (
    GradientPickerModule as {
      ColorPicker?: GradientPickerComponent;
      default?: GradientPickerComponent;
    }
  ).ColorPicker ??
  (
    GradientPickerModule as {
      ColorPicker?: GradientPickerComponent;
      default?: GradientPickerComponent;
    }
  ).default;

export function ColorPickerGradientArea({
  className,
}: ColorPickerGradientAreaProps) {
  const { mode, value, isNone, onChange } = useColorPickerContext();

  if (mode !== 'gradient') {
    return null;
  }

  if (!GradientPicker) {
    return (
      <div
        className={cn(
          'rounded-2xs border border-sys-style-neutral-light p-sm text-comp-moderate-medium text-sys-cont-neutral-light',
          className,
        )}
      >
        Gradient picker를 불러오지 못했습니다.
      </div>
    );
  }

  const fallbackGradient = 'linear-gradient(90deg, #FFFFFF 0%, #000000 100%)';
  const currentGradient = isNone
    ? fallbackGradient
    : (value ?? fallbackGradient);

  return (
    <div className={cn(isNone && 'pointer-events-none', className)}>
      <GradientPicker
        value={currentGradient}
        onChange={(nextValue: string) => onChange(nextValue)}
        hideColorGuide
      />
    </div>
  );
}
